import { jsx as _jsx } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : example for wiki templates
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import log from 'uix/logging';
// ---Globals
export const statistic = {
    match: ({ tag })=>tag == 'SomeWikiTag',
    build: ({ attrib })=>/*#__PURE__*/ _jsx(SomeReactComp, {
            ...attrib,
            children: "123"
        }),
    completion: ({})=>{
        return {
            '!top': [
                'SomeWikiTag'
            ],
            Statistic: {
                attrs: {
                    prop1: [
                        'domain.',
                        'datatype.',
                        'metadata.'
                    ]
                }
            }
        };
    }
};
